/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {NgModule} from '@angular/core';
import {EmailValidatorDirective} from './email-validator.directive';

@NgModule({
    declarations: [EmailValidatorDirective],
    exports: [EmailValidatorDirective],
})
export class EmailValidatorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/email/email-validator.module.ts